<template>
	<div class="page-content">
		
		<kyaneos-header />

		<div class="q-mt-xl"></div>
		<el-title :index="show_annexes ? 3 : 2">
			Méthode par capitalisation
		</el-title>

		<div class="comment">
			<el-textarea
				class="detail-site"
				:parent_data="active_study.etudeData.scpi.evaluation"
				property="commentaire_rendement"
				:editable="true"
				placeholder="Commentaire"
				:height="'60px'"
				overflow_edit='hidden scroll'
				text_align="justify"
			/>
		</div>
		<div class="q-mb-sm evaluation-mx">
			<el-table
				:table="table_verification"
				lines-box-class="left toper"
			/>
		</div>
		<div class="q-ma-lg">
			<div class="edit-button" v-show="editor.mode == 'editing'">
				<q-btn @click="calculateSum" color="primary" label="Récupérer les revenus locatifs annuels"/>
			</div>
		</div>
		<el-title :index="show_annexes ? 4 : 3">
			Conclusion
		</el-title>

		<el-checkbox
			v-if="editor.mode === 'editing'"
			:parent_data="active_study.etudeData.scpi.evaluation.conclusion_table"
			property="show_abattement"
			label="Afficher l'abattement pour vente en bloc"
			:editable="true"
			class="q-mt-md"
		/>

		<div class="q-mb-sm evaluation-mx">
			<el-table
				:table="table_conclusion"
				lines-box-class="left toper"
				class="table-conclusion"
			/>
			<p>valeur s'entendant hors frais et hors droits</p>
		</div>
		<div class="q-ma-lg">
			<div class="edit-button" v-show="editor.mode == 'editing'">
				<q-btn @click="calculerTableau" color="primary" label="Effectuer les calculs"/>
			</div>
		</div>
		<div class="q-mt-lg">
			<div class="tle-row items-center signature">
				<div class="tle-col half">
					Fait à Lyon le <el-textarea :parent_data="active_study.etudeData.scpi.evaluation" property="date_signature" :editable="true" inline />
				</div>
				<div class="tle-col half text-center">
					L. GOUTTENOIRE<br/>
					D.E.A. Droit des Affaires<br/>
					Expert près la Cour d’Appel de Lyon
					<img v-if="active_study.etudeData.scpi.evaluation.signed" src="@/assets/img/signature.png"/>
					<div class="q-ma-md edit-button" v-show="editor.mode == 'editing'">
						<q-btn @click="sign" color="primary" :label="active_study.etudeData.scpi.evaluation.signed ? 'Enlever la signature' : 'Signer'"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";

export default {
	components: { KyaneosHeader },
	name: "page-kyaneos-6",
	mixins: [ PageMixin ],
	props: [ "index" ],
	methods: {
		calculateSum: function (){
			let sumLoyers = 0;
			for (let lot of this.active_study.etudeData.kyaneosData.Lots){
				lot = parseFloat(lot.Loyer);
				if (!isNaN(lot)) {
					sumLoyers += lot;
				}
			}
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.scpi.evaluation.verification_table[0],
				field: "revenus",
				value: Math.round(sumLoyers * 12),
			});
		},
		sign: function (){
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.scpi.evaluation,
				field: "signed",
				value: !this.active_study.etudeData.scpi.evaluation.signed,
			});
			this.$store.dispatch("save_study");
		},
		getSommeAnnexes: function (annexes){
			let sommeAnnexes = 0;
			for (let i = 0; i < annexes.annexes_table_garages_nb_lignes; i++) {
				const val = annexes.annexes_table_garages[i];
				if(val.valeur_unitaire != 0){
					sommeAnnexes += (parseFloat(val.nb_lots) * parseFloat(val.valeur_unitaire));
				}
			}
			for (let i = 0; i < annexes.annexes_table_locaux_commerciaux_nb_lignes; i++) {
				const val = annexes.annexes_table_locaux_commerciaux[i];
				if(val.rendement != 0){
					sommeAnnexes += (parseFloat(val.revenus) / parseFloat(val.rendement)).toFixed(2) * 100;
				}
			}
			for (let i = 0; i < annexes.annexes_table_bureaux_nb_lignes; i++) {
				const val = annexes.annexes_table_bureaux[i];
				if( parseFloat(val.rendement) != 0){
					sommeAnnexes += (parseFloat(val.revenus) / parseFloat(val.rendement)).toFixed(2) * 100;
				}
			}
			return sommeAnnexes;
		},
		getSommeLogements: function (){
			const filteredLots = this.active_study.etudeData.kyaneosData.Lots.filter(lot => lot.TypeBail.toLowerCase().includes("habitation"));
			return filteredLots.reduce(function (accumulator, lot){
				const retenue = (lot.Surface * lot.valeur_metrique * (1 - lot.abattement_occupation / 100)).toFixed(2);
				return accumulator + parseFloat(isNaN(retenue) || !isFinite(retenue) ? 0 : retenue);
			}, 0);
		},
		updateMoyenneRetenue: function (valeur){
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.scpi.evaluation.conclusion_table,
				field: "moyenne_retenue",
				value: valeur,
			});
		},
		updateMethodeComparaison: function (valeur){
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.scpi.evaluation.conclusion_table,
				field: "methode_comparaison",
				value: valeur,
			});
			this.$store.dispatch("save_study");
		},
		updateMethodeRendement: function (valeur){
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.scpi.evaluation.conclusion_table,
				field: "methode_rendement",
				value: valeur,
			});
			this.$store.dispatch("save_study");
		},
		updateValeurApresAbattement: function (valeur){
			this.$store.commit("EDIT_OBJECT", {
				obj: this.active_study.etudeData.scpi.evaluation.conclusion_table,
				field: "valeur_apres_abattement",
				value: valeur,
			});
			this.$store.dispatch("save_study");
		},
		calculerTableau: function (){
			const evaluation = this.active_study.etudeData.scpi.evaluation;
			const loc = evaluation.conclusion_table;
			const verif = evaluation.verification_table[0];

			const methodeComparaison = this.getSommeAnnexes(evaluation) + this.getSommeLogements();
			this.updateMethodeComparaison(methodeComparaison);
			const rendement = (parseFloat(verif.revenus) / parseFloat(verif.rendement)).toFixed(2) * 100;
			this.updateMethodeRendement(isNaN(rendement) || !isFinite(rendement) ? "0" : rendement);
			if(loc.show_abattement) {
				this.updateValeurApresAbattement(loc.methode_comparaison * ((100 - parseFloat(loc.abattement)) / 100));
			}

		}
	},
	computed: {
		...mapGetters([ "active_study", "editor" ]),
		show_annexes () {
			return this.editor.mode === "editing" || this.active_study.etudeData.scpi.evaluation.show_annexes_commentaire || this.active_study.etudeData.scpi.evaluation.show_annexes_garages || this.active_study.etudeData.scpi.evaluation.show_annexes_locaux_commerciaux || this.active_study.etudeData.scpi.evaluation.show_annexes_bureaux;
		},
		table_verification: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [40, 30, 30],
				},
			};

			table.head.push(["Revenus locatifs annuels", "Taux de capitalisation retenu", "Valeur"]);

			const loc = this.active_study.etudeData.scpi.evaluation.verification_table[0];

			const calcul = (parseFloat(loc.revenus) / parseFloat(loc.rendement)).toFixed(2) * 100;

			table.body.push([
				{
					parent_data: loc,
					property: "revenus",
					editable: true,
					format: "number"
				},
				{
					parent_data: loc,
					property: "rendement",
					editable: true,
					suffix: "%",
					format: "number"
				},
				{
					value: isNaN(calcul) || !isFinite(calcul) ? "-" : calcul,
					suffix: "€",
					format: "number"
				}
			]);

			return table;
		},
		table_conclusion: function () {
			const evaluation = this.active_study.etudeData.scpi.evaluation;
			const loc = evaluation.conclusion_table;

			const table = {
				head: [],
				body: [],
				config: {},
			};

			table.head.push(["Désignation", "Valeurs"]);

			if(loc.show_abattement) {
				this.updateMoyenneRetenue(
					(
						(parseFloat(loc.valeur_apres_abattement) + parseFloat(loc.methode_rendement)) / 2
					).toString());
			}else{
				this.updateMoyenneRetenue(
					(
						(parseInt(loc.methode_comparaison) + parseInt(loc.methode_rendement)) / 2
					).toString());
			}
			const rows = [
				[
					"Méthode par comparaison logements / capitalisation des revenus pour les annexes",
					{
						parent_data: loc,
						property: "methode_comparaison",
						suffix: "€",
						editable: true,
						format: "number"
					},
				],
				[
					"Méthode par capitalisation",
					{
						parent_data: loc,
						property: "methode_rendement",
						suffix: "€",
						editable: true,
						format: "number"
					},
				],
				[
					{
						value: "Valeur moyenne retenue",
						classes: "total",
						bg_color: "gray",
						format: "number"
						
					},
					{
						value: loc.moyenne_retenue,
						suffix: "€",
						classes: "total",
						bg_color: "gray",
						format: "number"
					}
				]
			];

			if(loc.show_abattement) {
				rows.splice(1, 0, [
					"Abattement pour vente en bloc",
					{
						parent_data: loc,
						property: "abattement",
						suffix: "%",
						editable: true,
					}
				]);
				rows.splice(2,0, [
					"Valeur après abattement",
					{
						parent_data: loc,
						property: "valeur_apres_abattement",
						suffix: "€",
						editable: true,
						format: "number"
					}
				]);
			}

			table.body = rows;

			return table;
		},
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'

.table-conclusion >>> .el-row__cell.total {
	font-size 16px
	line-height normal
}
.table-conclusion >>> .el-row__cell {
	max-width: 360px
}
.edit-button
	text-align center
	z-index 20001
</style>